// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__36AFT","file":"styles_file__lS7kv"};